import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import FAQ from "../components/Fqas/FAQ";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import DarkRoadMap from "../components/dark-roadmap/darkRoadMap";
import SimpleModels from "../components/simpleEngagementModels";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import tabData from "../data/industryData";
import { useTranslation } from "react-i18next";
import { AiAutomationPageData } from "../data/ai-automation-agency";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import MegaMenu from "../components/MegaMenu/MegaMenu";

const AiAutomationAgency = () => {
  const { t } = useTranslation("footer");
  const footerCtaContent = t("footerCtaContent", { returnObjects: true });

  const { t: stackData } = useTranslation("aiDevelopmentPageContent");
  const coverTheStackData = stackData("aiDevCoverTheStackSection", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>
          AI Workflow Automation Services | Automation Agency Bitsclan
        </title>
        <meta
          name="description"
          content="Looking to hire the best AI automation agency? Bitsclan's AI & workflow automation services focus on ROI to maximize your productivity & profits. Experience effortless automations and take your business to the next level."
        />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading="Top AI Automation Development Agency"
        mainHeading="Reimagining the <span>Future of Business</span> Through Intelligent Automation"
        description="Searching for an AI automation agency that delivers real impact? At Bitsclan, we provide advanced AI automation services to cut costs, increase efficiency, & simplify operations. Our consulting helps you transform workflows & gain a competitive edge."
      />
      <TrustedPartner />

      <OurServices
        buttonText=" Automate all with AI"
        servicesCardsData={AiAutomationPageData?.services}
        shortHeading="AI-Powered Automation Services We Offer"
        mainHeading="Where <span>Automation</span> Meets Enterprise Transformation"
        description="We help businesses automate intelligently, not blindly. Our full suite of AI automation services is built to streamline your operations, accelerate development, & elevate user experience through the power of artificial intelligence."
      />

      <CoverTheStack
        shortHeading={"Tech Stack in Our AI- Based Automation Services"}
        whereStart={"AI Automation Tools"}
        mainHeading={"Behind Every Intelligent Solution Lies a Powerful Technology Stack"}
        subHeading={"Bitsclan delivers high-performance AI automation workflows using modern, scalable, & secure technologies. From cloud deployment to real-time learning engines, our tech stack supports every layer of your AI ecosystem."}
        tabs={AiAutomationPageData?.techStack?.tabs}
        tabItems={AiAutomationPageData?.techStack?.tabItems}
      />

      <NewTestimonials
        shortHeading="Our Clients Testimonials"
        mainHeading="Endorsed by Global <span>Partners</span> Driving Intelligent Automation"
        description="Businesses across industries trust Bitsclan for AI automation services. Their feedback proves how our solutions maximize performance, reduce overheads, & fuel innovation-driven growth."
        content={AiAutomationPageData?.testimonials}
      />

      <NewCaseStudySection
        shortHeading="AI Automation & Workflow Case Studies"
        heading="Real-World Success <span>Stories</span> in Intelligent Automation"
        description="Bitsclan offers advanced AI automation & workflow solutions to help companies save time, reduce costs, & engage customers more effectively. As a trusted automation agency, we design scalable systems backed by proven results & real business outcomes."
      />

      <PioneeringChange
        tabData={AiAutomationPageData?.industries?.tabData}
        serviceTags={AiAutomationPageData?.industries?.serviceTags}
        shortHeading="Industries We Serve"
        greenHeading={"Operate in the Age of AI"}
        mainHeading={"Reinventing How Industries "}
        content={
          "Driving innovation & transforming industries with advanced ai automation expertise & actionable insights."
        }
      />

      <SimpleModels content={AiAutomationPageData?.engagementModels} />

      <TrendsInsights
        category="ai-developmet"
        heading={AiAutomationPageData?.trendingInsights.heading}
        description={AiAutomationPageData?.trendingInsights.description}
      />

      <FAQ
        faqs={AiAutomationPageData.faqSection.questionAnswers}
        mainHeading={AiAutomationPageData.faqSection.heading}
      />
      <SoftwareCompanyCta content={AiAutomationPageData?.companyCta} />
      <Footer />
    </>
  );
};

export default AiAutomationAgency;
